import { render } from "./BoardTopContents.vue?vue&type=template&id=0d86938b"
import script from "./BoardTopContents.vue?vue&type=script&lang=js"
export * from "./BoardTopContents.vue?vue&type=script&lang=js"
script.render = render

export default script